/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Signer_HintInputs */

const vi_sinp_signer_hint = /** @type {(inputs: Sinp_Signer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Ký, ghi rõ họ tên)`)
};

/**

* @param {Sinp_Signer_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_signer_hint = /** @type {((inputs?: Sinp_Signer_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Signer_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_signer_hint(inputs)
});